import React, { ReactElement, useEffect } from 'react';
import {
  Box,
  Tab,
  tabClasses,
  Tabs,
  Stack,
  IconButton,
  Container,
} from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { styled } from '@mui/styles';
import { useAuth } from '../../auth/auth-hook';
import { CustomHeader } from '../../../shared/components/layout/CustomHeader';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { PROJECT_COLOR } from '../../../shared/constants';

const ROUTES = [
  {
    path: '/users',
    name: 'Usuarios registrados',
  },
  {
    path: '/users-subscribed',
    name: 'Usuarios suscritos',
  },
];

type Props = {
  children: ReactElement;
};

export const UsersLayout: React.FC<Props> = ({ children }) => {
  const [currentTab, setCurrentTab] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth();

  const TabItem = styled(Tab)({
    position: 'relative',
    borderRadius: '30px !important',
    textAlign: 'center',
    transition: 'all .5s',
    padding: '8px 10px !important',
    color: '#BBBBBB',
    height: '35px !important',
    margin: '6px 2px',
    float: 'none',
    lineHeight: '14px',
    fontSize: '14px',
    fontWeight: '700',
    minHeight: '38px',
    textTransform: 'capitalize',
    [`&.${tabClasses.selected}, &:hover`]: {
      color: PROJECT_COLOR ?? '#000000',
      backgroundColor: (PROJECT_COLOR ?? '#000000') + '20 !important',
    },
  });

  useEffect(() => {
    ROUTES.forEach((route, i) => {
      const path = route.path.replace(':id', id as string);
      if (path === location.pathname) {
        setCurrentTab(i + 1);
      }
    });
  }, [location.pathname, id]);

  const handleChange = (
    event: React.SyntheticEvent | null,
    newValue: number | null,
  ): void => {
    setCurrentTab(newValue ?? 0);
  };

  return (
    <>
      <CustomHeader
        title={`Bienvenido de vuelta, ${user?.name}`}
        subtitle={
          'Mide el IMPACTO de tus publicitaciones, registros, choques y tráfico del sitio web.'
        }
      />
      <Container
        maxWidth={'lg'}
        style={{
          borderRadius: '16px',
          background: 'white',
        }}>
        <Stack direction="column" width={'100%'} >
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              py: 1,
            }}>
            <Tabs
              sx={{
                padding: { sm: '0px 10px !important' },
                display: 'flex',
                justifyContent: 'space-between',
                '& .MuiTabs-indicator': {
                  display: 'none !important',
                },
                width: '100%',
              }}
              value={currentTab}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              allowScrollButtonsMobile>
              <IconButton
                onClick={() => navigate('/users')}
                sx={{ width: '30px', height: '30px', my: '10px' }}>
                <ArrowBackIosIcon sx={{ fontSize: 14 }} />
              </IconButton>

              {ROUTES.map((route, key) => (
                <TabItem
                  key={key}
                  label={route.name}
                  onClick={() => navigate(route.path)}
                />
              ))}
            </Tabs>
          </Box>
          <Box width="100%">{children}</Box>
        </Stack>
      </Container>
    </>
  );
};
